import { GTM_EVENTS } from './app.constants';

export const GA4_EVENT_NAMES: Record<keyof typeof GTM_EVENTS, string> = {
  ...GTM_EVENTS,
  appointment_booking_step_available_appointments_start: 'appointment_step_datetime_start',
  appointment_booking_step_available_appointments_end: 'appointment_step_datetime_end',
  appointment_booking_step_personal_data_start: 'appointment_step_personal_data_start',
  appointment_booking_step_personal_data_end: 'appointment_step_personal_data_end',
};
